export default "__VITE_ASSET__d0e983a2__"